// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","img":"Card_img__8Ehvv","btnDelete":"Card_btnDelete__rr2HL"};